import './public-path';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import routes from './router';
import api from '@/uilt/new-axios.js' // 记得改为你的路径
import { DonMessage, NameCheck, NameCheckBlur } from './uilt/messgePrompt'
// 引入并注册加载svg组件和图标
import SvgIcon from '@/components/SvgIcon.vue'
Vue.component('SvgIcon', SvgIcon)
// 自动加载所有 SVG 图标
const req = require.context('@/assets/icons', false, /\.svg$/)
req.keys().forEach(req)

Vue.prototype.api = api; // 此处命名为rq,你可以改
//通过key获取字典值
Vue.prototype.getCodeListByKey = function (key) {
  if (localStorage.codeList) {
    let codeList = JSON.parse(localStorage.codeList);
    let list = codeList.filter(item => item.dictTypeName == key)
    return list.length ? list[0].dictList : [];
  } else {
    console.log('localStorage.codeList is null', key, localStorage.codeList)
    return [];
  }
},
Vue.prototype.$getValueListByKey = function (key) {
  let list = Vue.prototype.getCodeListByKey(key);
  let arr=[]
  list.forEach(item=>{
    if(item.value){
      arr.push(item.value)
    }
  })
  return arr
},
  Vue.prototype.$getNameByKey = function (name, key) {
    let list = Vue.prototype.getCodeListByKey(key);
    let lisArr = list.filter(item => item.value == name);
    return lisArr.length ? lisArr[0].text : '-';
  }
Vue.prototype.$getNameByKey = function (name, key) {
  let list = Vue.prototype.getCodeListByKey(key);
  let lisArr = list.filter(item => item.value == name);
  return lisArr.length ? lisArr[0].text : '-';
}
Vue.prototype.$NewMessage = new DonMessage() // todo 重写的消息弹框
Vue.prototype.$NameCheck = NameCheck // todo 校验名称字数
Vue.prototype.$NameCheckBlur = NameCheckBlur // todo 校验名称字数
import "@/assets/style/style.css"
import '@/assets/style/icon.css';
import '@/assets/style/state.css';//状态样式模块
import '@/assets/style/moduleCommon.css';//页面公用模块样式
import "@/assets/style/popper.css" //全景数字地图公共样式
import "@/assets/style/table.less" //页面通用表格公共样式

import store from './store'
import moment from "moment"
Vue.prototype.$moment = moment;
import {
  UrlSearch
} from './uilt/urlSearch' //截取地址栏参数
let Request = new UrlSearch();
Vue.prototype.$Request = Request;
import * as filter from './filter'
Object.keys(filter).forEach(key => {
  Vue.filter(key, filter[key])
})
// 输入框千分位处理
import { NumThousands } from './uilt/thousands'//防止按钮多次点击
Vue.use(NumThousands)

import serverConfig from '@/assets/global/serverConfig';
import messageConfig from '@/assets/global/messageConfig';
window.serverConfig = serverConfig;
window.messageConfig = messageConfig;
import { preventReClick } from './uilt/preventReClick'//防止按钮多次点击
Vue.use(preventReClick)
Vue.config.productionTip = false;
// v26.3.3 数据标注：micro-app 微前端基座初始化（LS 等标注工具嵌入，见 certManagement/components/LabelToolEmbed.vue）
// Vue2 须忽略 micro-app 自定义元素，否则模板编译告警且不渲染；start 需在子应用挂载前执行
Vue.config.ignoredElements = [/^micro-app$/];
import microApp from '@micro-zoe/micro-app'
microApp.start();
// Vue.prototype.$axios = axios;
Vue.use(ElementUI);

import echarts from 'echarts'
import 'echarts/map/js/china.js';
import 'echarts/extension-src/bmap/bmap';
Vue.prototype.$echarts = echarts
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

let router = null;
let instance = null;
/* 延迟按钮点击指令 */
Vue.directive('dbClick', {
  inserted(el, binding) {
    console.log(el)
    el.addEventListener('click', e => {
      if (!el.disabled) {
        el.disabled = true
        el.style.cursor = 'not - allowed'
        setTimeout(() => {
          el.style.cursor = 'pointer'
          el.disabled = false
        }, 5000)
      }
    })
  }
})

/* 延迟按钮点击指令 */
Vue.directive('dbClick', {
  inserted(el, binding) {
    console.log(el)
    el.addEventListener('click', e => {
      if (!el.disabled) {
        el.disabled = true
        el.style.cursor = 'not - allowed'
        setTimeout(() => {
          el.style.cursor = 'pointer'
          el.disabled = false
        }, 5000)
      }
    })
  }
})
function render(props = {}) {
  const {
    container
  } = props;
  router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
  });

  // 路由守卫
  router.beforeEach((to, from, next) => {
    if (to.path === '/') {
      next('/login');
    } else if (to.path === '/portraitBMap') {
      // 通过idaas获取token
      const url = window.location.href;
      const urlObj = new URL(url);
      const state = urlObj.searchParams.get('state');
      if(state && state.indexOf('$') > -1){
        const stateArr = state.split('$');
        localStorage.state = stateArr[0];
        localStorage.token = stateArr[1];
        localStorage.refreshToken = stateArr[2];
      }
      next();
    } else {
      next();
    }
  })

  instance = new Vue({
    store,
    router,
    render: h => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app');
}

if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

function storeTest(props) {
  props.onGlobalStateChange &&
    props.onGlobalStateChange(
      (value, prev) => console.log(`[onGlobalStateChange - ${props.name}]:`, value, prev),
      true,
    );
  props.setGlobalState &&
    props.setGlobalState({
      ignore: props.name,
      user: {
        name: props.name,
      },
    });
}

export async function bootstrap() {
  console.log('[vue] vue app bootstraped');
}

export async function mount(props) {
  console.log('[vue] props from main framework', props);
  storeTest(props);
  render(props);
}

export async function unmount() {
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  router = null;
}
